// ──────────────────────────────────────────────────────────────
// Events for the Classification Wall MFE
// ──────────────────────────────────────────────────────────────

export const CLASSIFICATION_EVENTS = {
  // ── Warroom → MFE (inbound) ──────────────────────────────────
  INIT_POST_STATE: 'mfe-classification-wall-init-post-state',
  REMOVE_POST: 'mfe-classification-wall-remove-post',
  ERROR_COUNT_POSTS: 'mfe-classification-wall-count-posts-error',
  SUCCESS_COUNT_POSTS: 'mfe-classification-wall-count-posts-success',
  UPDATE_POSTS: 'mfe-classification-wall-update-posts',
  POSTS_COUNTED: 'mfe-classification-wall-posts-counted',
  REFRESH_POST_INTERACTIONS: 'mfe-classification-wall-refresh-post-interactions',

  // ── MFE → Warroom (outbound) ─────────────────────────────────
  LOADED: 'mfe-classification-wall-loaded',
  LOADING: 'mfe-classification-wall-loading',
  CARD_READY: 'mfe-classification-wall-card-ready',
  ERROR_LOADING: 'mfe-classification-wall-error-loading',

  // Card action buttons
  REPLY: 'mfe-classification-wall-reply',
  SIMILAR: 'mfe-classification-wall-similar',
  READ_ALL: 'mfe-classification-wall-read-all',
  INFO: 'mfe-classification-wall-info',
  COPY: 'mfe-classification-wall-copy',
  COPY_ID: 'mfe-classification-wall-copy-id',
  MARK_CHECKED: 'mfe-classification-wall-mark-checked',

  // Classification toggles
  GENDER_CHANGE: 'mfe-classification-wall-gender-change',
  SENTIMENT_CHANGE: 'mfe-classification-wall-sentiment-change',

  // Tag/chip add buttons
  ADD_GROUP: 'mfe-classification-wall-add-group',
  ADD_THEME: 'mfe-classification-wall-add-theme',
  ADD_INTEREST: 'mfe-classification-wall-add-interest',
  ADD_TAG: 'mfe-classification-wall-add-tag',

  // User-level actions
  REFRESH_DATA: 'mfe-classification-wall-refresh-data',
  BAN_USER: 'mfe-classification-wall-ban-user',
  REMOVE_FROM_SEARCH: 'mfe-classification-wall-remove-from-search',

  // File creation (MFE → Warroom)
  CREATE_FILE: 'mfe-classification-wall-create-file',

  // ── Multiple Edition (bulk) ───────────────────────────────────
  BULK_ADD_GROUP: 'mfe-classification-wall-bulk-add-group',
  BULK_ADD_THEME: 'mfe-classification-wall-bulk-add-theme',
  BULK_ADD_INTEREST: 'mfe-classification-wall-bulk-add-interest',
  BULK_ADD_TAG: 'mfe-classification-wall-bulk-add-tag',
  BULK_SENTIMENT_CHANGE: 'mfe-classification-wall-bulk-sentiment-change',
  BULK_GENDER_CHANGE: 'mfe-classification-wall-bulk-gender-change',
  BULK_APPLY_LOCAL: 'mfe-classification-wall-bulk-apply-local',
  BULK_REMOVE_FROM_SEARCH: 'mfe-classification-wall-bulk-remove-from-search',
  BULK_FILTER_ANNOTATE: 'mfe-classification-wall-bulk-filter-annotate',
  BULK_SELECTED_ANNOTATE: 'mfe-classification-wall-bulk-selected-annotate',

  // ── Warroom → MFE: toast notifications ───────────────────────
  NOTIFY_ANNOTATION_SUCCESS:    'mfe-classification-wall-annotation-success',
  NOTIFY_ANNOTATION_ERROR:      'mfe-classification-wall-annotation-error',
  NOTIFY_COPY_SUCCESS:          'mfe-classification-wall-copy-success',
  NOTIFY_COPY_ERROR:            'mfe-classification-wall-copy-error',
  NOTIFY_COPY_ID_SUCCESS:       'mfe-classification-wall-copy-id-success',
  NOTIFY_COPY_ID_ERROR:         'mfe-classification-wall-copy-id-error',
  NOTIFY_REFRESH_SUCCESS:       'mfe-classification-wall-refresh-success',
  NOTIFY_REFRESH_ERROR:         'mfe-classification-wall-refresh-error',
  NOTIFY_BAN_USER_LOADING:      'mfe-classification-wall-ban-user-loading',
  NOTIFY_BAN_USER_SUCCESS:      'mfe-classification-wall-ban-user-success',
  NOTIFY_BAN_USER_ID_ERROR:     'mfe-classification-wall-ban-user-id-error',
  NOTIFY_REMOVE_FROM_SEARCH_SUCCESS: 'mfe-classification-wall-remove-from-search-success',
  NOTIFY_REMOVE_FROM_SEARCH_ERROR:   'mfe-classification-wall-remove-from-search-error',
  NOTIFY_REPLY_SUCCESS:         'mfe-classification-wall-reply-success',
  NOTIFY_REPLY_ERROR:           'mfe-classification-wall-reply-error',

  // File creation notifications (Warroom → MFE)
  NOTIFY_CREATE_FILE_SUCCESS:   'mfe-classification-wall-create-file-success',
  NOTIFY_CREATE_FILE_ERROR:     'mfe-classification-wall-create-file-error',

  // Bulk filter annotation notifications (Warroom → MFE)
  NOTIFY_BULK_FILTER_ANNOTATE_SUCCESS: 'mfe-classification-wall-bulk-filter-annotate-success',

  // Bulk selected annotation notifications (Warroom → MFE)
  NOTIFY_BULK_SELECTED_ANNOTATE_SUCCESS: 'mfe-classification-wall-bulk-selected-annotate-success',

  // Bulk error notifications (Warroom → MFE)
  NOTIFY_BULK_COMMUNICATION_ERROR: 'mfe-classification-wall-bulk-communication-error',
  NOTIFY_BULK_SOME_ANNOTATION_ERROR: 'mfe-classification-wall-bulk-some-annotation-error',
  NOTIFY_BULK_CLASSIFICATION_ERROR: 'mfe-classification-wall-bulk-classification-error',

} as const;

export type ClassificationEventName =
  (typeof CLASSIFICATION_EVENTS)[keyof typeof CLASSIFICATION_EVENTS];
